{
  "ai_evaluating_description": "We are analyzing the responses to provide you with insights. This may take a few minutes.",
  "ai_evaluating_title": "AI analysis in progress",
  "ai_summary_highlights_description": "What people shared that really stood out",
  "ai_summary_highlights_title": "%APP_AI_NAME% highlights",
  "ai_waiting_description": "Analysis will begin after the survey is completed and responses are collected.",
  "ai_waiting_title": "AI is ready for analysis",
  "assistant": "Assistant",
  "assistant_action_approve_time_off_request": "Approve time off request",
  "assistant_action_cancel_time_off_request": "Cancel time off request",
  "assistant_action_cancelled": "Action cancelled.",
  "assistant_action_checkin_goal": "Update goal progress",
  "assistant_action_create_form_scale": "Create rating scale",
  "assistant_action_create_form_template": "Create form template",
  "assistant_action_create_form_template_folder": "Create template folder",
  "assistant_action_create_goal": "Create goal",
  "assistant_action_create_key_result": "Add key result",
  "assistant_action_create_performance_review_draft": "Create performance review draft",
  "assistant_action_create_survey_draft": "Create survey draft",
  "assistant_action_create_time_off_request": "Request time off",
  "assistant_action_default": "Confirm the action",
  "assistant_action_done": "Done.",
  "assistant_action_duplicate_form_template": "Duplicate form template",
  "assistant_action_duplicate_performance_review": "Duplicate performance review",
  "assistant_action_duplicate_survey": "Duplicate survey",
  "assistant_action_failed": "The action couldn't be completed.",
  "assistant_action_give_recognition": "Give recognition",
  "assistant_action_move_form_template": "Move form template",
  "assistant_action_open": "Open",
  "assistant_action_reject_time_off_request": "Reject time off request",
  "assistant_action_update_form_template": "Update form template",
  "assistant_action_update_form_template_form": "Update template questions",
  "assistant_action_update_goal": "Update goal",
  "assistant_action_update_key_result": "Update key result",
  "assistant_action_update_performance_review": "Update performance review",
  "assistant_action_update_performance_review_form": "Update review form",
  "assistant_action_update_survey": "Update survey",
  "assistant_action_update_survey_form": "Update survey questions",
  "assistant_attach_file": "Attach a file",
  "assistant_busy": "The assistant is still answering. Wait for the answer or stop it.",
  "assistant_cancel_all": "Cancel all",
  "assistant_confirm_all": "Confirm all ({count})",
  "assistant_disclaimer": "%APP_ASSISTANT_NAME% is AI and can make mistakes",
  "assistant_download_csv": "Download CSV",
  "assistant_empty": "Ask about colleagues, time off, goals, reviews, surveys and people analytics. I can also request and approve time off, set up surveys and reviews from templates, edit form templates, give recognition, update goals and read your files.",
  "assistant_error": "The assistant can't respond right now. Please try again.",
  "assistant_feature_description": "Employees ask the assistant about goals, colleagues and time off and update goal progress without leaving the page",
  "assistant_feature_title": "AI Assistant",
  "assistant_field_anonymous_threshold": "Anonymity threshold",
  "assistant_field_comment": "Comment",
  "assistant_field_create_new_form": "Start with an empty form",
  "assistant_field_date_ends_at": "Ends",
  "assistant_field_date_from": "From",
  "assistant_field_date_starts_at": "Starts",
  "assistant_field_date_to": "To",
  "assistant_field_emoji": "Emoji",
  "assistant_field_form": "Questions",
  "assistant_field_invitation": "Invitation",
  "assistant_field_invitation_body": "Invitation text",
  "assistant_field_invitation_subject": "Invitation subject",
  "assistant_field_is_share_employee_after_completion": "Share results after completion",
  "assistant_field_items": "{count, plural, one {# item} other {# items}}",
  "assistant_field_options": "Options",
  "assistant_field_participant_reviewers": "Reviewers",
  "assistant_field_participants_rule_groups": "Participants",
  "assistant_field_questions": "{count, plural, one {# question} other {# questions}}",
  "assistant_field_ratings": "Ratings",
  "assistant_field_reminders": "Reminders",
  "assistant_field_reviewer_types": "Reviewer types",
  "assistant_field_share_employee_rule_groups": "Results shared with",
  "assistant_field_target_type": "Copy as",
  "assistant_field_type": "Type",
  "assistant_field_use_ai": "AI summary",
  "assistant_file_too_large": "The file is larger than 4.5 MB.",
  "assistant_file_type_unsupported": "This file type isn't supported. Attach xlsx, xls, csv, pdf, docx or txt.",
  "assistant_greeting": "Hi, I'm %APP_ASSISTANT_NAME%",
  "assistant_input_placeholder": "Ask %APP_ASSISTANT_NAME%",
  "assistant_interrupted": "The response was interrupted.",
  "assistant_limit_exceeded": "You've reached the assistant request limit for this period. Contact your administrator to increase it.",
  "assistant_name": "%APP_ASSISTANT_NAME%",
  "assistant_permission_description": "Allow users to ask the AI Assistant questions",
  "assistant_permission_title": "Access to the assistant",
  "assistant_question_too_long": "The question is longer than 8,000 characters. Shorten it.",
  "assistant_resize": "Resize the assistant panel",
  "assistant_retry": "Retry",
  "assistant_send": "Send",
  "assistant_show_all_rows": "Show all ({count})",
  "assistant_stop": "Stop",
  "assistant_stopped": "Stopped.",
  "assistant_suggestion_checkin": "Update progress on my goal",
  "assistant_suggestion_goals": "What are my goals and what's behind?",
  "assistant_suggestion_review": "How did my team do in the last review?",
  "assistant_suggestion_time_off": "Who is on time off this week?",
  "assistant_thinking": "Thinking…",
  "assistant_thread_delete": "Delete conversation",
  "assistant_thread_delete_confirm": "Delete this conversation? It can't be restored.",
  "assistant_thread_new": "New conversation",
  "assistant_threads": "Conversations",
  "assistant_threads_empty": "No conversations yet.",
  "assistant_title": "Ask %APP_ASSISTANT_NAME%",
  "assistant_tool_approve_time_off_request": "Approving the time off request…",
  "assistant_tool_cancel_time_off_request": "Cancelling the time off request…",
  "assistant_tool_check_time_off_request": "Checking the time off request…",
  "assistant_tool_checkin_goal": "Updating goal progress…",
  "assistant_tool_create_form_scale": "Creating a rating scale…",
  "assistant_tool_create_form_template": "Creating the form template…",
  "assistant_tool_create_form_template_folder": "Creating a template folder…",
  "assistant_tool_create_goal": "Creating a goal…",
  "assistant_tool_create_key_result": "Adding a key result…",
  "assistant_tool_create_performance_review_draft": "Creating a review draft…",
  "assistant_tool_create_survey_draft": "Creating a survey draft…",
  "assistant_tool_create_time_off_request": "Requesting time off…",
  "assistant_tool_default": "Working with data…",
  "assistant_tool_done": "done",
  "assistant_tool_duplicate_form_template": "Duplicating the form template…",
  "assistant_tool_duplicate_performance_review": "Duplicating the review…",
  "assistant_tool_duplicate_survey": "Duplicating the survey…",
  "assistant_tool_failed": "failed",
  "assistant_tool_get_employee": "Looking at an employee…",
  "assistant_tool_get_employee_by_email": "Looking up an employee by email…",
  "assistant_tool_get_employee_time_off_balance": "Checking time off balance…",
  "assistant_tool_get_employee_time_off_calendar": "Looking at the time off calendar…",
  "assistant_tool_get_form_template": "Opening the form template…",
  "assistant_tool_get_goal": "Looking at a goal…",
  "assistant_tool_get_help_article": "Reading help article…",
  "assistant_tool_get_me": "Looking at your profile…",
  "assistant_tool_get_my_inbox": "Checking your inbox…",
  "assistant_tool_get_performance_review_form": "Opening the review form…",
  "assistant_tool_get_performance_review_participant_report": "Looking at a participant's review report…",
  "assistant_tool_get_performance_review_results": "Looking at review results…",
  "assistant_tool_get_performance_review_setup": "Opening review settings…",
  "assistant_tool_get_performance_review_stats": "Looking at review stats…",
  "assistant_tool_get_survey_form": "Opening the survey form…",
  "assistant_tool_get_survey_results": "Looking at survey results…",
  "assistant_tool_get_survey_setup": "Opening survey settings…",
  "assistant_tool_give_recognition": "Giving recognition…",
  "assistant_tool_list_analytics_columns": "Checking analytics columns…",
  "assistant_tool_list_employee_columns": "Checking employee columns…",
  "assistant_tool_list_employee_time_off_categories": "Looking at time off types…",
  "assistant_tool_list_form_template_folders": "Checking template folders…",
  "assistant_tool_list_performance_review_participants": "Checking review participants…",
  "assistant_tool_list_rule_conditions": "Checking selection rules…",
  "assistant_tool_move_form_template": "Moving the form template…",
  "assistant_tool_preview_performance_review_change": "Checking review changes…",
  "assistant_tool_preview_rules": "Checking who matches…",
  "assistant_tool_preview_survey_change": "Checking survey changes…",
  "assistant_tool_query_people_analytics": "Building people analytics…",
  "assistant_tool_reject_time_off_request": "Rejecting the time off request…",
  "assistant_tool_search_employee_time_off": "Searching time off…",
  "assistant_tool_search_employees": "Searching employees…",
  "assistant_tool_search_form_scales": "Searching rating scales…",
  "assistant_tool_search_form_templates": "Searching form templates…",
  "assistant_tool_search_goals": "Searching goals…",
  "assistant_tool_search_help": "Searching help…",
  "assistant_tool_search_performance_reviews": "Searching performance reviews…",
  "assistant_tool_search_recognitions": "Searching recognitions…",
  "assistant_tool_search_rule_condition_options": "Searching rule options…",
  "assistant_tool_search_survey_answers": "Searching survey answers…",
  "assistant_tool_search_survey_participants": "Searching survey participants…",
  "assistant_tool_search_surveys": "Searching surveys…",
  "assistant_tool_search_time_off_calendar": "Searching the time off calendar…",
  "assistant_tool_update_form_template": "Updating the form template…",
  "assistant_tool_update_form_template_form": "Updating template questions…",
  "assistant_tool_update_goal": "Updating a goal…",
  "assistant_tool_update_key_result": "Updating a key result…",
  "assistant_tool_update_performance_review": "Updating the review…",
  "assistant_tool_update_performance_review_form": "Updating the review form…",
  "assistant_tool_update_survey": "Updating the survey…",
  "assistant_tool_update_survey_form": "Updating survey questions…",
  "assistant_value_double_scale": "Double scale",
  "assistant_value_performance_review": "Performance review",
  "assistant_value_single_scale": "Single scale",
  "assistant_value_survey": "Survey",
  "based_on_ai": "Based on %APP_AI_NAME% analysis",
  "calculate": "Calculate",
  "calculating_match": "Calculating match...",
  "calculating_match_description": "This might take up to 10 minutes",
  "calculation_failed": "Calculation failed",
  "calculation_failed_description": "Unable to calculate the score. Please try again",
  "edit_score": "Edit score",
  "match_not_calculated": "Match not calculated",
  "match_score": "Match score",
  "match_title": "match",
  "recalculate": "Recalculate",
  "request_calculate": "Request calculation manually",
  "~": "~"
}
